<template>
  <div>
    <!-- History button -->
    <button type="button" class="btn btn-outline-primary float-end btn-sm" style="margin-top: -40px" data-bs-toggle="modal" :title="title" :data-bs-target="'#modal-' + extra.serial + '-' + extra.id" @click="modalState = Date.now()">
      <i class="fas fa-chart-bar"></i>
    </button>
    <!-- Settings modal -->
    <div class="modal fade" :id="'modal-' + extra.serial + '-' + extra.id" ref="modal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Sulge"></button>
          </div>
          <div class="modal-body">
            <!-- Chart -->
            <apexchart v-if="chartOptions !== null" height="450" :options="chartOptions" :series="chartOptions.series"></apexchart>
            <div v-else class="d-flex justify-content-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <!-- Filters -->
            <div v-if="extra.advanced" class="row">
              <!-- Selected parameters -->
              <div class="col">
                <input-tag id="selectedParameters" v-model="parameters"></input-tag>
              </div>
              <!-- Add parameters -->
              <div class="col-2">
                <select class="form-select" id="selectParameters" v-model="parameterSelector" @change="addParameter($event)">
                  <option value="null">Lisa parameeter</option>
                  <option v-for="(device, name) in $store.getters.device(extra.serial)" :key="name" :value="name">{{ name }}</option>
                </select>
              </div>
              <!-- Filter button -->
              <div class="col-2">
                <div class="d-grid">
                  <button class="btn btn-primary" @click="requestChart">Uuenda</button>
                </div>
              </div>
            </div>
            <div v-if="extra.advanced && 1 === 2">
              device: {{ $store.getters.device(extra.serial) }}
              <br><br>
              extra: {{ extra }}
              <br><br>
              advanced: {{ extra.advanced }}
              <br><br>
              parameters: {{ parameters }}
              <br><br>
              chartOptions: {{ chartOptions }}
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Sulge</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'extra'],
  data () {
    return {
      modalState: 0,
      parameters: [],
      chartOptions: null,
      parameterSelector: null
    }
  },
  sockets: {
    // TODO replace with actual event
    getDetailChart: function (data) {
      if (data.reqData.serial === this.extra.serial && data.reqData.chartId === this.extra.id) {
        console.log('getDetailChart:', data)
        this.chartOptions = data.chartOptions
      }
    }
  },
  watch: {
    modalState: function () {
      this.parameters = this.extra.parameters
      console.log('modal state changed')
      this.requestChart()
    }
  },
  mounted () {
    this.parameters = this.extra.parameters
  },
  methods: {
    addParameter (e) {
      if (this.parameters.findIndex(obj => obj === e.target.value) === -1 && e.target.value !== null && e.target.value !== 'serial') {
        this.parameters.push(e.target.value)
        this.parameterSelector = null
      }
    },
    requestChart () {
      this.chartOptions = null
      // TODO replace with actual request
      console.log('chart req:', { serial: this.extra.serial, parameters: this.parameters, chartId: this.extra.id })
      this.$socket.emit('getDetailChart', { serial: this.extra.serial, parameters: this.parameters, chartId: this.extra.id })
    }
  }
}
</script>
